/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Sessions_NoneInputs */

const th_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีเซสชัน`)
};

const en_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sessions yet.`)
};

const ja_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションはまだありません。`)
};

const zh_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无课程。`)
};

const es_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay sesiones.`)
};

const pt_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma sessão ainda.`)
};

const id_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesi.`)
};

const fr_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance pour l’instant.`)
};

const tl_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang sesyon.`)
};

const vi_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có buổi nào.`)
};

const ko_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 세션이 없습니다.`)
};

const de_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Einheiten.`)
};

const ru_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Занятий пока нет.`)
};

const tr_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz oturum yok.`)
};

const it_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna sessione.`)
};

const pl_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze zajęć.`)
};

const uk_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Занять поки немає.`)
};

const hi_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई सत्र नहीं।`)
};

const ar_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد حصص بعد.`)
};

const ms_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sesi.`)
};

const bn_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও সেশন নেই।`)
};

const zh_tw2_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無課程。`)
};

const zh_hk2_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無課節。`)
};

const ur_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی سیشن نہیں۔`)
};

const fa_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز جلسه‌ای نیست.`)
};

const sw_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna vipindi bado.`)
};

const nl_event_sessions_none = /** @type {(inputs: Event_Sessions_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen sessies.`)
};

/**
* | output |
* | --- |
* | "No sessions yet." |
*
* @param {Event_Sessions_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_sessions_none = /** @type {((inputs?: Event_Sessions_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Sessions_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_sessions_none(inputs)
	if (locale === "ja") return ja_event_sessions_none(inputs)
	if (locale === "zh") return zh_event_sessions_none(inputs)
	if (locale === "es") return es_event_sessions_none(inputs)
	if (locale === "pt") return pt_event_sessions_none(inputs)
	if (locale === "id") return id_event_sessions_none(inputs)
	if (locale === "fr") return fr_event_sessions_none(inputs)
	if (locale === "tl") return tl_event_sessions_none(inputs)
	if (locale === "vi") return vi_event_sessions_none(inputs)
	if (locale === "ko") return ko_event_sessions_none(inputs)
	if (locale === "de") return de_event_sessions_none(inputs)
	if (locale === "ru") return ru_event_sessions_none(inputs)
	if (locale === "tr") return tr_event_sessions_none(inputs)
	if (locale === "it") return it_event_sessions_none(inputs)
	if (locale === "pl") return pl_event_sessions_none(inputs)
	if (locale === "uk") return uk_event_sessions_none(inputs)
	if (locale === "hi") return hi_event_sessions_none(inputs)
	if (locale === "ar") return ar_event_sessions_none(inputs)
	if (locale === "ms") return ms_event_sessions_none(inputs)
	if (locale === "bn") return bn_event_sessions_none(inputs)
	if (locale === "zh-TW") return zh_tw2_event_sessions_none(inputs)
	if (locale === "zh-HK") return zh_hk2_event_sessions_none(inputs)
	if (locale === "ur") return ur_event_sessions_none(inputs)
	if (locale === "fa") return fa_event_sessions_none(inputs)
	if (locale === "sw") return sw_event_sessions_none(inputs)
	if (locale === "nl") return nl_event_sessions_none(inputs)
	return en_event_sessions_none(inputs)
});